const prefix = '/product'

export { prefix }

